// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qv_L","fullView":"styles_fullView__fvS3V"};